import { dateFormat } from 'utils/helpers/date'

export const formatDate = (date: string, type: 'DATE' | 'TIME' = 'DATE'): string =>
  dateFormat({
    date: new Date(date),
    format: type === 'DATE' ? 'YYYY-MM-DD' : 'HH:mm:ss',
    locale: 'id',
  })
